module.exports = [
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2000",
    "Rate": 278.4
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2002-2004",
    "Rate": 326.5
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2005-2007",
    "Rate": 356
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2010",
    "Rate": 266.2
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2011-2013",
    "Rate": 256.1
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2014-2016",
    "Rate": 255.2
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "Black, not Hispanic",
    "Year": "2018",
    "Rate": 241.7
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2000",
    "Rate": 128.77
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2002-2004",
    "Rate": 153.97
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2005-2007",
    "Rate": 176.77
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2010",
    "Rate": 137.23
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2011-2013",
    "Rate": 146.53
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2014-2016",
    "Rate": 153.6
  },
  {
    "AgeGroup": "25-34 years",
    "Race": "White, not Hispanic",
    "Year": "2018",
    "Rate": 169.85
  }
]
